import { render } from "./selectModal.vue?vue&type=template&id=3f7c3f1c"
import script from "./selectModal.vue?vue&type=script&lang=js"
export * from "./selectModal.vue?vue&type=script&lang=js"
script.render = render

export default script